"use strict";

var _core = require("@emotion/core");

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var React = __importStar(require("react"));

var utils_1 = require("../../utils"); // @ts-ignore


exports.Image = utils_1.forwardRef(function Image(props, ref) {
  var src = props.src,
      alt = props.alt,
      title = props.title,
      fallbackAction = props.fallbackAction,
      rest = __rest(props, ["src", "alt", "title", "fallbackAction"]);

  var className = rest.className || '';

  var _a = React.useState(false),
      error = _a[0],
      setError = _a[1];

  React.useEffect(function () {
    if (error && fallbackAction) {
      fallbackAction();
    }
  }, [error]);
  return !error && (0, _core.jsx)("img", {
    src: src,
    alt: alt,
    onError: function onError() {
      return setError(true);
    },
    className: className
  });
});